import { Component, Inject, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  MatFormField,
  MatHint,
  MatInput,
  MatLabel,
} from '@angular/material/input';
import { FullCalendarComponent } from '../full-calendar/full-calendar.component';

@Component({
  selector: 'app-calendar-date-picker-dialog',
  templateUrl: './calendar-date-picker-dialog.component.html',
  styleUrl: './calendar-date-picker-dialog.component.css',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatButton,
    FullCalendarComponent,
  ],
})
export class CalendarDatePickerDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CalendarDatePickerDialogComponent>);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      storeId: number;
      sendoutId?: number;
      selectedDate: Date;
    }
  ) {}

  handleDateSelected(date: Date) {
    this.dialogRef.close({
      confirmed: true,
      date: date,
    });
  }
}
